import React from 'react';
import { ArrowRightIcon, XIcon, CheckIcon } from 'lucide-react';
import { Reveal } from './Reveal';
import { transformations } from '../data/content';
export function TransformationSection() {
  return <section className="w-full bg-navy-900 py-20 lg:py-24" aria-labelledby="transformation-heading" style={{
    paddingTop: "0px",
    paddingBottom: "0px"
  }} data-id="element-187" data-mp="2wx48vkjr0uoy">
      <div className="mx-auto max-w-7xl px-6 lg:px-8" data-id="element-188" data-mp="2s0nazymqz1yo">
        <Reveal className="max-w-3xl" data-id="element-189" data-mp="2ny0s4n820rdm">
          <h2 id="transformation-heading" className="text-3xl font-black leading-tight tracking-tight text-white sm:text-4xl lg:text-5xl" data-id="element-190" data-mp="2nz23ksszffvv">
            What changes when you implement this system
          </h2>
          <p className="mt-4 text-lg leading-relaxed text-slate-300" data-id="element-191" data-mp="2e4tdebrfbz0v">
            Same market. Same hours in the day. A completely different business underneath you.
          </p>
        </Reveal>

        <div className="mt-14 grid grid-cols-1 gap-6 lg:grid-cols-3" data-id="element-192" data-mp="24at19pxq5tin">
          {transformations.map((item, i) => <Reveal key={item.label} delay={i * 0.06} className="h-full" data-id="element-193" data-mp="209r196vzhdfm" data-mpi={i}>
              <article className="flex h-full flex-col rounded-2xl border border-white/10 bg-navy-800 p-7" data-id="element-194" data-mp="f9rf55bagjm0">
                <h3 className="text-xs font-bold uppercase tracking-widest text-slate-400" data-id="element-195" data-mp="k3vn9rwaixoo">{item.label}</h3>

                <ul className="mt-5 space-y-3" data-id="element-196" data-mp="5b1vb6zu0p34">
                  {item.before.map(line => <li key={line} className="flex gap-3 text-[15px] leading-relaxed text-slate-400" data-id="element-197" data-mp="acizbbdm4rnx">
                      <XIcon aria-hidden="true" className="mt-0.5 h-4 w-4 shrink-0 text-slate-500" data-id="element-198" data-mp="y2d73ej2rq1b" />
                      <span className="line-through decoration-slate-500" data-id="element-199" data-mp="12zvhzagnkfby">{line}</span>
                    </li>)}
                </ul>

                <div className="my-6 flex items-center gap-3" aria-hidden="true" data-id="element-200" data-mp="t2h1xbyn5sk6">
                  <span className="h-px flex-1 bg-white/10" data-id="element-201" data-mp="t4bpyz57m0sh" />
                  <span className="inline-flex h-8 w-8 items-center justify-center rounded-full bg-brand-gold text-navy-900" data-id="element-202" data-mp="39qbiktcpnh3b">
                    <ArrowRightIcon className="h-4 w-4" data-id="element-203" data-mp="3dqll1w1anpdf" />
                  </span>
                  <span className="h-px flex-1 bg-white/10" data-id="element-204" data-mp="1k9fyez4533c4" />
                </div>

                <ul className="mt-auto space-y-3" data-id="element-205" data-mp="1fc7d4pnp2j6n">
                  {item.after.map(line => <li key={line} className="flex gap-3 text-[15px] font-semibold leading-relaxed text-white" data-id="element-206" data-mp="1ajnx7m1jbbyo">
                      <CheckIcon aria-hidden="true" className="mt-0.5 h-4 w-4 shrink-0 text-brand-gold" data-id="element-207" data-mp="15k1n3lh06bu3" />
                      {line}
                    </li>)}
                </ul>
              </article>
            </Reveal>)}
        </div>
      </div>
    </section>;
}